import Cookies from "js-cookie";

/** Hook to determine if user is from SG or not. */
export const useCountry = () => {
  if (typeof window === "undefined") return { isSGUser: true };

  const isSGUser = Cookies.get("sph_user_country") === "SG";

  if (typeof isSGUser === "undefined") return { isSGUser: true };

  return { isSGUser };
};
